var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.9003C14.8667 13.9003 14.3 14.1503 13.8667 14.542L7.925 11.0837C7.96667 10.892 8 10.7003 8 10.5003C8 10.3003 7.96667 10.1087 7.925 9.91699L13.8 6.49199C14.25 6.90866 14.8417 7.16699 15.5 7.16699C16.8833 7.16699 18 6.05033 18 4.66699C18 3.28366 16.8833 2.16699 15.5 2.16699C14.1167 2.16699 13 3.28366 13 4.66699C13 4.86699 13.0333 5.05866 13.075 5.25033L7.2 8.67533C6.75 8.25866 6.15833 8.00033 5.5 8.00033C4.11667 8.00033 3 9.11699 3 10.5003C3 11.8837 4.11667 13.0003 5.5 13.0003C6.15833 13.0003 6.75 12.742 7.2 12.3253L13.1333 15.792C13.0917 15.967 13.0667 16.1503 13.0667 16.3337C13.0667 17.6753 14.1583 18.767 15.5 18.767C16.8417 18.767 17.9333 17.6753 17.9333 16.3337C17.9333 14.992 16.8417 13.9003 15.5 13.9003Z",
    fill: "#EE3932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9041756dc7ac701ba2cdd201c6c7352a.svg";
export { ForwardRef as ReactComponent };